import { render, staticRenderFns } from "./ModulePendencies.vue?vue&type=template&id=13f21de8"
import script from "./ModulePendencies.vue?vue&type=script&lang=js"
export * from "./ModulePendencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports